module.exports = new __parcel__URL__("gradient-phrases-words.2e305684.mp4").toString();